class MapPOILoader {

    constructor() {
        this.urlPage = new URL (document.URL);
        this.urlParams =  new URLSearchParams(this.urlPage.search);
        this.mapPOILoaderResult = document.querySelector('#map');
        this.mapPOILoaderResultTable = document.querySelector('#map-point-table');

        this.ppmapSearchAdress = document.querySelector('#ppmapSearchAdress');
        this.ppmapSearchAdressButton = document.querySelector('#ppmapSearchAdressButton');

        this.ppmapBtnShowFilters = document.querySelector('#ppmapBtnShowFilters');
        this.ppmapBtnShowFiltersLabel = document.querySelector('#ppmapBtnShowFiltersLabel');
        this.ppmapBtnShowFiltersBefor = document.querySelector('#ppmapBtnShowFiltersBefor');


        this.ppmapProvince = document.querySelector('#ppmapProvince');
        this.ppmapDistrict = document.querySelector('#ppmapDistrict');
        this.ppmapDistrictPreloader = document.querySelector('#ppmapDistrictPreloader');

        this.formSearchPoi = document.querySelector('#searchPoiItem');
        this.ppmapError = document.querySelector('#ppmapError');
        this.formSearchPoiData = new FormData(this.formSearchPoi);
        this.ppmapDistance = document.querySelector('#ppmapDistance');

        this.mapa = {};
        this.ppmapZoom = 5.5;
        this.markerPopupSelectedPoint = {};
        this.selectedPointMarker = {};
        this.distanceCircleOnMap = {};
        this.distanceCircleTimeout = {};

        this.selectedPoint = {};
        this.defaultMapPoint = {lat:52.067519, lng:19.4770837, val:'Piątek Łódzkie Polska'};

        this.xhr = new XMLHttpRequest();
        this.xhr.overrideMimeType("application/json");

        this.setSubmit();
        this.makeInteractiveFiltersTab();

        this.makeInteractiveZoom();
        this.makeInteractiveProvince();
        this.makeInteractiveDistrict();
        this.makeInteractiveFiltersInner();

    }

    setSubmit() {

        this.ppmapSearchAdressButton.addEventListener('click', ()=>{
            submitForm();
        });

        this.ppmapSearchAdress.addEventListener('keydown', (e) => {
            if (e.key === "Enter") {
                e.preventDefault(); // Prevent the default form submission
                submitForm();
            }
        });

        // this.ppmapSearchAdress.addEventListener('change', (e) => {
        //    !e.target.value ? this.selectedPoint = {} : '';
        // });

        const submitForm = () => {
            this.prepareData();

            if(this.formValidate()) {

                this.fetchAddressesListFromApiPP()
                    .then(data => {
                        if(data.length>0){
                            let e = { 'selected': {
                                    'lat': data[0].latitude,
                                    'lng': data[0].longitude,
                                    'val': data[0].label
                                }
                            }

                            this.ppmapSearchAdress.value = data[0].value;
                            this.ppwidgetOnSubmit(e);
                        } else {
                            this.showMapError();
                        }
                    });


            } else {
                console.log('Niepoprawnie wypełniony formularz!');
            }
        }


    }

    fetchAddressesListFromApiPP() {
        let searchQuery = this.ppmapSearchAdress.value;
        let url = `https://api.poczta-polska.pl/maps/v1/search/address/json?api-version=1.0&subscription-key=${ppkey}&countrySet=PL&language=pl-PL&typeahead=true`;
        url = url +'&query='+encodeURIComponent(searchQuery);

        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Accept-Encoding', 'gzip, deflate, br');
        headers.append('Accept-Language', 'en-US,en;q=0.9,pl;q=0.8,pl-PL;q=0.7');
        headers.append('Connection', 'keep-alive');
        headers.append('Host', 'api.poczta-polska.pl');
        headers.append('Sec-Fetch-Dest', 'empty');
        headers.append('Sec-Fetch-Mode', 'cors');
        headers.append('Sec-Fetch-Site', 'cross-site');

        return fetch(url, {
            method: 'GET',
            headers: headers,
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                return data.results.map(item => {
                    let name = [
                        item.address.streetName,
                        item.address.streetNumber,
                        item.address.postalCode,
                        item.address.municipalitySubdivision,
                        item.address.municipality,
                        item.address.countrySubdivisionName,
                        item.address.country
                    ].filter(Boolean).join(' ');

                    return {
                        'latitude': item.position.lat,
                        'longitude': item.position.lon,
                        'label': name.replace(this.ppmapSearchAdress.value, '<strong>' + this.ppmapSearchAdress.value + '</strong>'),
                        'value': name
                    }
                })
            })
            .catch(error => {
                throw 'There was a problem with the fetch operation';
            });
    }

    getTabsFiltersValue(){
        let ppmapTabsFilters = document.querySelectorAll('#ppmapTabsFilters input');
        let ret = null;
        ppmapTabsFilters.forEach(item=>{
            if(item.checked) { ret = item.value; }
        });
        return ret;
    }

    findCoordinates (ui) {
        let xhr = new XMLHttpRequest();

        let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/coordinates.php";
        let data = new FormData();

        data.append('value',ui.value);
        data.append('type',ui.type);
        data.append('province',ui.province);
        data.append('zipcode',ui.zipcode);
        data.append('label',ui.label);
        data.append('pid',ui.pid);
        data.append('latitude',ui.latitude);
        data.append('longitude',ui.longitude);
        data.append('distance',this.ppmapDistance.value);

        xhr.open("POST", url, true);
        xhr.send(data);

        xhr.onload = () => {

            if (xhr.status !== 200) {
                console.log(`Error ${xhr.status}: ${xhr.statusText}`);
            } else {
                console.log(xhr.response);
                console.log('wyświetlenie mapy ... ');
            }
        };

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                //console.log(xhr.responseText);
            }
        };

        xhr.onerror = () => console.log("Request failed");

    }

    autocompleteInput() {

        let poi = this;
        let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/search.php?tab=" + poi.formSearchPoi.ppmapBox_Filters.value;

        poi.prepareData();

        jQuery( "#ppmapSearchAdress" ).autocomplete({
            source:function (request, response) {
                request.tab = poi.formSearchPoi.ppmapBox_Filters.value;

                poi.formSearchPoiData.forEach((value, key) => {
                    request[key] = value;
                });

                const ppPOIList = fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'Accept': 'application/json, text/javascript, */*; q=0.01'
                    },
                    body: new URLSearchParams(request),
                })
                    .then(response => {
                        // Check if the request was successful (status code 200-299)
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }

                        // Parse the response JSON and return it
                        return response.json();
                    });

                const addressesList = poi.fetchAddressesListFromApiPP();

                Promise.all([ppPOIList, addressesList])
                    .then(dataArray => {
                        let [ppPOIListResult, addressesListResult] = dataArray;

                        ppPOIListResult = ppPOIListResult?.length > 5 ? ppPOIListResult.slice(0,5) : ppPOIListResult;
                        addressesListResult = addressesListResult?.slice(0, 10-ppPOIListResult.length);

                        let responseCombinedData = ppPOIListResult.length === 1 && ppPOIListResult[0].label === "Brak danych" ? [...addressesListResult] : [...ppPOIListResult,...addressesListResult];

                        response(responseCombinedData);
                    })
                    .catch(error => console.error('Fetch error:', error));
            },
            minLength: 2,
            select: function( event, ui ) {

                const marker = !ui.item.hasOwnProperty('pid');

                let e = {'selected':{'lng':null,'lat':null,'val':null}};

                e.selected.lng = ui.item.longitude;
                e.selected.lat = ui.item.latitude;
                e.selected.val = ui.item.value;

                poi.ppmapProvince.value=0;
                poi.ppmapDistrictSelectReset('powiat');

                !marker ? poi.addPopupForSelectedPoint([e.selected.lat, e.selected.lng]) : poi.removePopupForPrevSelectedPoint();

                poi.ppwidgetOnSubmit(e,marker);

            }
        }).data("ui-autocomplete")._renderItem = function (ul, item) {

            return jQuery("<li></li>")
                .data("item.autocomplete", item)
                .append("<a>" + item.label + "</a>") //+ "<span>" + item.province + "</span>" + " "
                .appendTo(ul);
        };

    }

    autocompleteInputDestroy() {

        if(this.ppmapSearchAdress.classList.contains('ui-autocomplete')) {
            jQuery( "#ppmapSearchAdress" ).autocomplete('destroy');
        }

    }

    formValidate() {
        this.hideMapError();
        if(this.ppmapSearchAdress.value.length<3) {
            this.ppmapError.innerHTML = 'Wybierz adres z listy lub adres jest zbyt krótki min. 3 znaki';
            return false;
        }
        return true;
    }

    makeInteractiveFiltersTab() {
        let ppmapTabsFilters = document.querySelectorAll('#ppmapTabsFilters input');
        ppmapTabsFilters.forEach(item=>{
            if(item.checked) {
                this[item.value]();
            }

            item.addEventListener( 'change', ()=>{
                this[item.value]();
                this.filtersActiveCount();
                this.getFilteredMarkers(true);
            });
        });
    }

    makeInteractiveZoom() {
        this.ppmapDistance.addEventListener('change', (e) => {
            this.ppmapZoom = this.calculateMapZoom();
            const map = PPWidgetApp.getMap();

            if(this.ppmapSearchAdress.value) {
                map.setView(this.selectedPoint, this.ppmapZoom);
                this.drawDistanceCircle();
                this.getFilteredMarkers();
            }
        });
    }

    makeInteractiveFiltersInner() {
        let ppmapBox = document.querySelectorAll('.card-body [name^="ppmapBox_"]');
        ppmapBox.forEach(item=>{
            item.addEventListener( 'change', (e)=>{
                this.autocompleteInputDestroy();
                this.autocompleteInput();
                this.filtersActiveCount();
                this.getFilteredMarkers(true);
            });
        });
    }

    getLanguage(){
        return (this.urlPage.pathname=='/en/znajdz-punkt/') ? 'en' : 'pl';
    }

    filtersActiveCount() {

        const lang = this.getLanguage();
        let filtrLabel = {};
        filtrLabel = ('en'==lang)
            ? { label:'filters', show:'+Show', hide:'-Hide' }
            : { label:'filtry', show:'+Pokaż', hide:'-Ukryj' };

        let filters = document.querySelectorAll('.pp-map-search-header__service-points input');
        let counter = 0;
        filters.forEach((filter)=>{
            (filter.checked) ? counter++ : null;
        });
        this.ppmapBtnShowFiltersLabel.innerHTML = (counter<1) ? ` ${filtrLabel.label}` : ` ${filtrLabel.label} (${counter})`;

        jQuery('#collapseShowFilters').on('show.bs.collapse', (e) => {
            this.ppmapBtnShowFiltersBefor.innerHTML = filtrLabel.hide;
        })

        jQuery('#collapseShowFilters').on('hide.bs.collapse', (e) => {
            this.ppmapBtnShowFiltersBefor.innerHTML = filtrLabel.show;
        })

    }

    ppmapDistrictSelectReset(item) {

        let provinceLabel = 'powiat';
        provinceLabel = ('en'==this.getLanguage()) ? 'province' : 'powiat';

        this.ppmapDistrict.value = null;

        while (this.ppmapDistrict.options.length > 0) {
            this.ppmapDistrict.remove(0);
        }

        if(item!=null) {
            let myOption;
            myOption = document.createElement("option");
            myOption.text = provinceLabel;
            myOption.value = '0';
            this.ppmapDistrict.appendChild(myOption);
        }

    }

    makeInteractiveDistrict() {
        this.ppmapDistrict.addEventListener('change',(e)=>{
            this.ppmapDistance.value = 0;
            this.prepareData();
            this.getFilteredMarkers(true);
        });
    }

    addProvince(voi){

        if(null === voi){
            return;
        }

        let xhr = new XMLHttpRequest();
        let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/province.php";

        const district = this.urlParams.get('dis');

        let provinceLabel = 'powiat';
        provinceLabel = ('en'==this.getLanguage()) ? 'province' : 'powiat';

        let data = new FormData();
        data.append('province',voi);
        xhr.open("POST", url, true);
        xhr.send(data);
        xhr.onload = ()=>{
            if (xhr.status !== 200) {
                console.log(`Error ${xhr.status}: ${xhr.statusText}`);
            } else {
                this.ppmapDistrictSelectReset();
                let myJSON;
                myJSON = JSON.parse(xhr.response);

                let myOption;
                myOption = document.createElement("option");
                myOption.text = provinceLabel;
                myOption.value = '0';
                this.ppmapDistrict.appendChild(myOption);

                myJSON.district.forEach((item)=>{
                    let myOption;
                    myOption = document.createElement("option");
                    myOption.text = item;
                    myOption.value = item;
                    this.ppmapDistrict.appendChild(myOption);
                });

                if(null !== district && null !== voi){

                    if(myJSON.district.includes(district)){
                        this.ppmapDistrict.value = district;

                        let xhr = new XMLHttpRequest();
                        let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/province.php";

                        let data = new FormData();
                        data.append('province',district);
                        xhr.open("POST", url, true);
                        xhr.send(data);

                        xhr.onload = () => {
                            if (xhr.status !== 200) {
                                console.log(`Error ${xhr.status}: ${xhr.statusText}`);
                            } else {
                                this.getFilteredMarkers(true);
                            }
                        }

                    }

                }

            }
        }
    }

    makeInteractiveProvince() {
        this.ppmapProvince.addEventListener('change',(e)=>{

            this.ppmapDistance.value = 0;
            this.ppmapDistrictSelectReset('powiat');

            if('0'!==e.target.value) {
                if(!this.selectedPoint?.val.toLowerCase().includes(e.target.value)) {
                    this.selectedPoint = this.defaultMapPoint;
                    this.ppmapSearchAdress.value = null;
                }

                this.prepareData();
                this.getFilteredMarkers(true);

                let xhr = new XMLHttpRequest();
                let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/province.php";

                let data = new FormData();
                data.append('province',e.target.value);
                data.append('lang',this.getLanguage());
                xhr.open("POST", url, true);
                xhr.send(data);

                let provinceLabel = 'powiat';
                provinceLabel = ('en'==this.getLanguage()) ? 'province' : 'powiat';

                this.ppmapDistrictPreloader.style.display = 'flex';

                xhr.onload = () => {
                    if (xhr.status !== 200) {
                        console.log(`Error ${xhr.status}: ${xhr.statusText}`);
                    } else {

                        this.ppmapDistrictSelectReset();

                        let myJSON;
                        myJSON = JSON.parse(xhr.response);

                        let myOption;
                        myOption = document.createElement("option");
                        myOption.text = provinceLabel;
                        myOption.value = '0';
                        this.ppmapDistrict.appendChild(myOption);

                        myJSON.district.forEach((item)=>{
                            let myOption;
                            myOption = document.createElement("option");
                            myOption.text = item;
                            myOption.value = item;
                            this.ppmapDistrict.appendChild(myOption);
                        });

                    }
                    this.ppmapDistrictPreloader.style.display = 'none';
                };

                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        //console.log(xhr.responseText);
                    }
                };

                xhr.onerror = () => console.log("Request failed");

            } else {
                let pointDetails = this.ppmapSearchAdress.value ? this.selectedPoint : this.defaultMapPoint;
                let showMarker = !!this.ppmapSearchAdress.value;
                this.ppwidgetOnSubmit({selected: pointDetails}, showMarker);
                // this.ppmapDistrictSelectReset('powiat');
            }
        })
    }

    getFilteredMarkers(clearOldMarkers = false) {
        const currentMap = PPWidgetApp.getMap();
        let xhr = new XMLHttpRequest();
        let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/find-markers.php";
        let data = new FormData();

        this.prepareData();

        data.append('tab',this.getTabsFiltersValue());

        data.append('lng',this.selectedPoint.lng);
        data.append('lat',this.selectedPoint.lat);
        data.append('val',this.selectedPoint.val);
        data.append('distance',this.ppmapDistance.value);
        data.append('province',this.ppmapProvince.value);
        data.append('district',this.ppmapDistrict.value);

        const filtersValues = [...this.formSearchPoiData.entries()];
        filtersValues.forEach(item=>{
            data.append(item[0],item[1]);
        });

        xhr.open("POST", url, true);
        xhr.send(data);

        xhr.onload = () => {
            if (xhr.status !== 200) {
                console.log(`Error ${xhr.status}: ${xhr.statusText}`);
            } else {
                // this.selectedPointMarker ? currentMap.removeLayer(this.selectedPointMarker) : '';
                this.removePopupForPrevSelectedPoint();
                if(clearOldMarkers) PPWidgetApp.clearMarkers();

                let markers = [];
                let res;
                let bounds;

                res = JSON.parse(xhr.response);

                if(!res.length) {
                    this.showMapError();
                } else {
                    this.hideMapError();
                }

                this.calculateMapZoom();

                this.nearestPoints(res);

                res.forEach((item,index)=>{

                    let markerDetails = {
                        //name: `22222` + item.name,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        type: item.typ,
                        pni: item.pni
                    };

                    const nearPointsTypesList = item.nearPoints.split(',');
                    const currentTabFilter = this.getTabsFiltersValue();
                    if(currentTabFilter === 'tabAll' || nearPointsTypesList.includes(currentTabFilter)) {
                        switch(true){
                            case item.pinRotation === "right":
                                markerDetails['r'] = true;
                                break;
                            case item.pinRotation === "left":
                                markerDetails['l'] = true;
                                break;
                        }
                    }



                    markers[index] = PPWidgetApp.generateMarker(markerDetails).on('click', ()=> {
                        this.openTooltip(item.pni);
                        currentMap.setView([item.latitude, item.longitude], currentMap._zoom);
                        this.markElementOnList(item.latitude, item.longitude);
                    });
                    //tooltip ewentualnee fłłumaczenie
                    //markers[index]._tooltip._content = `3333 ${markers[index]._tooltip._content}`;

                });

                if(clearOldMarkers) PPWidgetApp.addMarkers(markers);

                if(!markers.length) {
                    currentMap.setView(this.defaultMapPoint, 5.5);
                    return;
                }

                if(this.ppmapZoom === 0) {
                    bounds = PPWidgetApp.getBounds(markers);
                    PPWidgetApp.fitBounds(bounds);
                } else {
                    currentMap.setView(this.selectedPoint,currentMap._zoom);
                }

            }
        }

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                //console.log(xhr.responseText);
            }
        };

        xhr.onerror = () => console.log("Request failed");
    }

    markElementOnList(latitude, longitude) {
        this.mapPOILoaderResultTable.querySelectorAll('.points__box-wrapper').forEach(elem => elem.classList.remove('active'));
        const targetElementOnList = this.mapPOILoaderResultTable.querySelector(`[data-lat="${latitude}"][data-lng="${longitude}"]`);

        targetElementOnList ? targetElementOnList.classList.add('active') : '';
        if(window.innerWidth >= 990) {
            if(targetElementOnList) {
                this.mapPOILoaderResultTable.scrollTop = targetElementOnList.offsetTop - this.mapPOILoaderResultTable.offsetTop;
            }
        } else {
            if(targetElementOnList) {
                this.mapPOILoaderResultTable.scrollLeft = targetElementOnList.offsetLeft - 24; //plus padding left of inner-container
            }
        }
    }

    tabAll(){
        this.hideAndResetFilters();

        this.addFilter('#ppmapBox_CurrencyExchange');
        this.addFilter('#ppmapBox_PickupAtPocztexPoint');
        this.addFilter('#ppmapBox_ECommerce');
        this.addFilter('#ppmapBox_Weight20Plus');
        this.addFilter('#ppmapBox_Weight30To50');
        this.addFilter('#ppmapBox_KEP');
        this.addFilter('#ppmapBox_PostOfficeBoxes');
        this.addFilter('#ppmapBox_MoneyExpress');
        this.addFilter('#ppmapBox_pocztexBroadcasting');
        this.addFilter('#ppmapBox_COD');
        this.addFilter('#ppmapBox_card');
        this.addFilter('#ppmapBox_HoursOfEmptying');
        this.addFilter('#ppmapBox_SpecialNeeds');
        this.addFilter('#ppmapBox_flixBus');

    }
    tabPocztexAutomat() {
        this.hideAndResetFilters();

        this.addFilter('#ppmapBox_PickupAtPocztexPoint');
        this.addFilter('#ppmapBox_pocztexBroadcasting');
        this.addFilter('#ppmapBox_COD');
        this.addFilter('#ppmapBox_card');
    }
    tabPostOffice() {
        this.hideAndResetFilters();

        this.addFilter('#ppmapBox_ECommerce');
        this.addFilter('#ppmapBox_Weight20Plus');
        this.addFilter('#ppmapBox_Weight30To50');
        this.addFilter('#ppmapBox_CurrencyExchange');
        this.addFilter('#ppmapBox_KEP');
        this.addFilter('#ppmapBox_PostOfficeBoxes');
        this.addFilter('#ppmapBox_MoneyExpress');
        this.addFilter('#ppmapBox_PickupAtPocztexPoint');
        this.addFilter('#ppmapBox_flixBus');

    }
    tabPocztexPoint() {
        this.hideAndResetFilters();

        this.addFilter('#ppmapBox_PickupAtPocztexPoint');
        this.addFilter('#ppmapBox_pocztexBroadcasting');
        this.addFilter('#ppmapBox_COD');
        this.addFilter('#ppmapBox_card');
    }
    tabOutbox() {
        this.hideAndResetFilters();

        this.addFilter('#ppmapBox_HoursOfEmptying');
        this.addFilter('#ppmapBox_SpecialNeeds');
    }

    hideAndResetFilters() {

        this.autocompleteInputDestroy();
        this.autocompleteInput();

        let filters = document.querySelectorAll('.pp-map-search-header__service-points input');
        filters.forEach((filter)=>{
            filter.checked = false;
            filter.setAttribute('disabled','');
            filter.parentNode.classList.add('disabled');
        })
    }

    addFilter(selectorId) {
        let el = document.querySelector(selectorId);
        if(typeof el == 'object'){
            // el.setAttribute('disabled',0);
            el.removeAttribute('disabled');
            el.parentNode.classList.remove('disabled');
        }


        //CurrencyExchange
        //PickupAtPocztexPoint
        //pocztexBroadcasting
        //PostOfficeBoxes
        //Weight20Plus
        //Weight30To50
        //MoneyExpress
        //ECommerce
        //KEP
        //COD
        //card
        //HoursOfEmptying
        //SpecialNeeds
        //flixBus

        let tab = new Array(
            'CurrencyExchange','PickupAtPocztexPoint',
            'pocztexBroadcasting','PostOfficeBoxes',
            'Weight20Plus','Weight30To50',
            'MoneyExpress','ECommerce',
            'KEP','COD','card',
            'HoursOfEmptying','SpecialNeeds','flixBus'
        );



        tab.forEach((item)=>{

            if('#ppmapBox_'+item==selectorId && 1==this.urlParams.get(item)){
                el.checked = true;
            }

        });


    }

    prepareData() {

        this.formSearchPoiData= new FormData(this.formSearchPoi);

        for ( var i = 0; i < this.formSearchPoi.elements.length; i++ ) {
            let e = this.formSearchPoi.elements[i];
            let val;

            if('checkbox' === e.type) {
                val = (true===e.checked) ? 1 :0;
            } else if ('radio' === e.type){
                val = (true === e.checked) ? e.value : undefined;
            } else {
                val = e.value;
            }

            if( typeof val !== 'undefined') {
                this.formSearchPoiData.append(e.name,val);
            }

        }

    }

    preload(){
        return '<div class="spinner-border text-primary mt-5" role="status"><span class="visually-hidden">Loading…</span></div>';
    }

    showMapError(message = "Brak wyników") {
        this.ppmapError.innerHTML = message;
        this.ppmapError.classList.remove('d-none');
        this.ppmapError.classList.add('d-block');
    }

    hideMapError() {
        this.ppmapError.innerHTML = null;
        this.ppmapError.classList.add('d-none');
        this.ppmapError.classList.remove('d-block');
    }

    openTooltip(id) {
        const para = document.createElement('div');
        const overlay = document.createElement('div');
        const body = document.createElement('div');
        const preloader = document.createElement('div');
        const rounding = document.createElement('div');
        let close = '';

        let xhr = new XMLHttpRequest();
        let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/point-info.php";

        let data = new FormData();
        data.append('pointid',id);
        data.append('lang',this.getLanguage());
        xhr.open("POST", url, true);
        xhr.send(data);

        xhr.onload = () => {
            if (xhr.status !== 200) {
                console.log(`Error ${xhr.status}: ${xhr.statusText}`);
            } else {
                document.body.style.overflow = "hidden";
                body.innerHTML = xhr.responseText;
                preloader.remove();

                close = document.querySelector('.pp-map-tooltip__close');
                close.addEventListener('click',()=>{
                    para.remove();
                    document.body.style.overflow = "";
                });

                window.addEventListener('keydown', (e)=> {
                    if (e.key === "Escape") {
                        para.remove();
                        document.body.style.overflow = "";
                    }
                });
            }

        };

        xhr.onreadystatechange = () => {
            body.classList.remove('pp-map-tooltip__loading');
            if (xhr.readyState === 4) {
                //console.log(xhr.responseText);
            }
        };

        xhr.onerror = () => console.log("Request failed");


        para.classList.add('pp-map-tooltip');
        para.appendChild(overlay);
        overlay.classList.add('pp-map-tooltip__overlay');
        overlay.appendChild(body);
        overlay.appendChild(rounding);
        body.classList.add('pp-map-tooltip__body');
        body.classList.add('pp-map-tooltip__loading');
        rounding.classList.add('pp-map-tooltip__rounding');
        // body.appendChild(inner);

        preloader.classList.add('pp-map-tooltip__preload');
        body.appendChild(preloader);
        preloader.innerHTML = this.preload();
        // inner.classList.add('pp-map-tooltip__inner');

        document.body.appendChild(para);
    }

    ppwidgetOnSubmit(selectedPoint,showMarker = true) {
        selectedPoint = selectedPoint ?? {selected: this.defaultMapPoint};

        let mapa = PPWidgetApp.getMap();
        let point;
        let zoom;

        this.mapPOILoaderResultTable.innerHTML = null;
        mapa._sizeChanged = true;
        this.selectedPoint = selectedPoint.selected;

        this.getFilteredMarkers(true);

        // PPWidgetApp.clearMarkers();
        this.selectedPointMarker ? mapa.removeLayer(this.selectedPointMarker) : '';
        if(showMarker) {
            point = L.marker(this.selectedPoint);
            point.addTo(mapa);
            point.bindPopup(`<b>${this.selectedPoint.val}</b><br>wybrana lokalizacja.`);

            this.selectedPointMarker = point;
        }

        this.drawDistanceCircle();

        this.calculateMapZoom();

        this.ppmapSearchAdress.value ? mapa.setView(this.selectedPoint, this.ppmapZoom) : mapa.setView([this.defaultMapPoint.lat, this.defaultMapPoint.lng],5.5);

        if(0<Number(this.urlParams.get('zoom'))){
            mapa.setView(this.selectedPoint, this.ppmapZoom)
        }

    }

    calculateMapZoom() {
        let zoom;
        const distance = Number(this.ppmapDistance.value);

        if(distance===1)         zoom = 15;
        else if(distance===5)    zoom = 12.75;
        else if(distance===10)   zoom = 11.75;
        else if(distance===20)   zoom = 10.75;
        else if(distance===40)   zoom = 9.75;
        else if(distance>40)     zoom = 8.75;
        else if(distance===0)    {
            if(this.ppmapSearchAdress.value) zoom = 15;
            else {
                if(Number(this.ppmapProvince.value) !== 0) zoom = 0;
                else zoom = 5.5;
            }
        }

        this.ppmapZoom = zoom;
        let z = Number(this.urlParams.get('zoom'));

        if(0<z){
            this.ppmapZoom = z;
            zoom = z;
        }

        return zoom;
    }

    mapZoomToDistance(zoom) {
        if (zoom > 13) {
            return 2_000;
        } else if (zoom > 12 && zoom <= 13) {
            return 7_000;
        } else if (zoom > 11 && zoom <= 12) {
            return 14_000;
        } else if (zoom > 10 && zoom <= 11) {
            return 25_000;
        } else if (zoom <= 10) {
            return 50_000;
        } else {
            return 70_000;
        }
    }

    drawDistanceCircle() {
        let mapa = PPWidgetApp.getMap();
        this.distanceCircleOnMap ? mapa.removeLayer(this.distanceCircleOnMap) : '';
        this.distanceCircleTimeout ? clearTimeout(this.distanceCircleTimeout) : '';

        this.distanceCircleOnMap = L.featureGroup();

        L.circle([this.selectedPoint.lat, this.selectedPoint.lng], {
            fillColor: '#f03',
            fillOpacity: 0.07,
            radius: Number(this.ppmapDistance.value) * 1000,
            weight: 0,
        }).addTo(this.distanceCircleOnMap);
        mapa.addLayer(this.distanceCircleOnMap);

        this.distanceCircleTimeout = setTimeout(()=>{
            mapa.removeLayer(this.distanceCircleOnMap);
        }, 7000);
    }

    nearestPoints(points) {
        if(!points.length ||
            (!this.ppmapSearchAdress.value && this.selectedPoint === this.defaultMapPoint && this.ppmapProvince.value === '0') ) {
            this.mapPOILoaderResultTable.classList.add('d-none');
            return;
        }

        const currentMap = PPWidgetApp.getMap();

        let distanceSelect = Number(this.ppmapDistance.value);


        distanceSelect = distanceSelect ? this.ppmapDistance.value * 1000 : !this.ppmapSearchAdress.value && this.ppmapProvince.value !== '0' ? 1_000_000 : this.mapZoomToDistance(currentMap._zoom);
        distanceSelect = (distanceSelect==2000) ? 5000 : distanceSelect;

        let pointsLimit = 300;
        points = this.sortPointsFromTheCloses(points);


        pointsLimit = (points.length<pointsLimit) ? points.length : pointsLimit;

        const tab = points.filter((point, idx) => point.distance <= distanceSelect && idx <= pointsLimit).map(point => point.pni);

        let xhr = new XMLHttpRequest();
        let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/nearest-points.php";
        let data = new FormData();
        data.append('tab',tab);
        data.append('selected_point_lng',this.selectedPoint.lng);
        data.append('selected_point_lat',this.selectedPoint.lat);
        data.append('lang',this.getLanguage());

        xhr.open("POST", url, true);
        xhr.send(data);

        xhr.onload = () => {

            if (xhr.status !== 200) {
                this.mapPOILoaderResultTable.classList.add('d-none');
                this.mapPOILoaderResultTable.innerHTML = null;
                console.log(`Error ${xhr.status}: ${xhr.statusText}`);
            } else {

                this.mapPOILoaderResultTable.innerHTML = xhr.response;
                let pointsBoxList = document.querySelectorAll('.points__box-wrapper');
                // this.mapPOILoaderResultTable.classList.remove('d-none');

                if(pointsBoxList.length || pointsBoxList[0]?.getAttribute('data-distance-m') < distanceSelect || !this.ppmapSearchAdress.value) {
                    this.mapPOILoaderResultTable.classList.remove('d-none');
                } else {
                    this.mapPOILoaderResultTable.innerHTML = null;
                    this.mapPOILoaderResultTable.classList.add('d-none');

                    currentMap._sizeChanged = true;
                    currentMap.setView(this.selectedPoint, currentMap._zoom);

                    return;
                }

                pointsBoxList.forEach((item) => {
                    item.addEventListener('click', ()=> {
                        const pointCoordinates = [item.getAttribute('data-lat'),item.getAttribute('data-lng')]

                        this.addPopupForSelectedPoint(pointCoordinates);

                        currentMap.setView(pointCoordinates, this.calculateMapZoom() ? this.ppmapZoom : 16);
                        this.markElementOnList(pointCoordinates[0], pointCoordinates[1]);
                    });

                    const buttonShowMore = item.querySelector('button.btn');
                    buttonShowMore.addEventListener('click',(e)=>{
                        let pni = e.target.getAttribute('data-pni');
                        if(pni !== null){
                            this.openTooltip(pni);
                        } else {
                            alert('Brak poprawnego ID');
                        }
                    });
                });

                if(this.ppmapSearchAdress.value) {
                    currentMap._sizeChanged = true;
                    currentMap.setView(this.selectedPoint, currentMap._zoom);
                }
            }
        };

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                //console.log(xhr.responseText);
            }
        };

        xhr.onerror = () => console.log("Request failed");

    }

    sortPointsFromTheCloses(points) {

        const calcDistanceBetweenTwoPoints = (lat1, lon1, lat2, lon2) => {
            // Convert latitude and longitude from degrees to radians
            const toRadians = angle => angle * (Math.PI / 180);
            const dLat = toRadians(lat2 - lat1);
            const dLon = toRadians(lon2 - lon1);

            // Haversine formula
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            // Earth radius in meters
            const earthRadius = 6371000;

            // Calculate the distance
            return earthRadius * c;
        }

        points = points.map(point => {
            const distance = calcDistanceBetweenTwoPoints(this.selectedPoint.lat, this.selectedPoint.lng, point.latitude, point.longitude);
            return {...point, 'distance': distance};
        });

        points.sort((point1, point2) => {
            return point1.distance - point2.distance;
        });

        return points;
    }

    addPopupForSelectedPoint(coordinates) {
        const currentMap = PPWidgetApp.getMap();

        this.removePopupForPrevSelectedPoint();
        this.markerPopupSelectedPoint = L.marker(coordinates).addTo(currentMap);
        this.markerPopupSelectedPoint.setOpacity(0);
        this.markerPopupSelectedPoint.bindPopup('Wybrany punkt');
        this.markerPopupSelectedPoint.openPopup();
    }

    removePopupForPrevSelectedPoint() {
        const currentMap = PPWidgetApp.getMap();
        this.markerPopupSelectedPoint ? currentMap.removeLayer(this.markerPopupSelectedPoint) : '';
    }

    setUrlAttribute() {
        let urlParams = new URLSearchParams(this.urlPage.search);
        this.urlParams = urlParams;
    }

    setUrlFiltersType(){

        const form = document.forms.searchPoiItem;
        const radios = form.elements.ppmapBox_Filters;
        const filter = this.urlParams.get('filters');

        if('pocztexAutomat'==filter){
            radios.value = 'tabPocztexAutomat';
            this.tabPocztexAutomat();
        } else if('postOffice'==filter) {
            radios.value = 'tabPostOffice';
            this.tabPostOffice();
        } else if('pocztexPoint'==filter) {
            radios.value = 'tabPocztexPoint';
            this.tabPocztexPoint();
        } else if('outbox'==filter) {
            radios.value = 'tabOutbox';
            this.tabOutbox();
        } else {
            radios.value = 'tabAll';
            this.tabAll();
        }

    }

    setUrlDays(){

        const form = document.forms.searchPoiItem;
        const radios = form.elements.ppmapBox_Days;
        const days = this.urlParams.get('days');

        if('24h'==days){
            radios.value = '24h';
        } else if('workingDays'==days) {
            radios.value = 'workingDays';
        } else if('soboty'==days || 'saturdays'==days) {
            radios.value = 'soboty';
        } else if('sunday'==days) {
            radios.value = 'niedziele i święta';
        } else if('workingDays'==days) {
            radios.value = 'dni robocze';
        } else {
            radios.value = 'dni robocze';
        }

    }

    setUrlProvince() {
        const voivodeship = this.urlParams.get('voi');
        const voivodeshipTab = [];

        this.ppmapProvince.querySelectorAll('option').forEach((item, index) => {
            voivodeshipTab.push(item.value);
        });

        this.ppmapProvince.value = (voivodeshipTab.includes(voivodeship)) ? voivodeship : 0;
        this.addProvince(this.ppmapProvince.value);
    }

    setUrlDistance(){

        let distance = parseInt(Number(this.urlParams.get('distance')));
        if(null===distance) return false;
        if(0===distance) return false;
        if(distance<0) return false;
        if(distance>0 && distance<2) { distance=1 }
        if(distance>1 && distance<5) { distance=5 }
        if(distance>5 && distance<10) { distance=10 }
        if(distance>10 && distance<20) { distance=20 }
        if(distance>20 && distance<40) { distance=40 }
        if(40<distance){ distance = 40;}

        const lat = Number(this.urlParams.get('lat'));
        const lng = Number(this.urlParams.get('lng'));

        if( isNaN(lat) || isNaN(lng) ) return false;
        // if( 0==lat || 0===lng ) return false;

        if(0===lat || 0===lng){

            if(0===Object.keys(this.selectedPoint).length){
                this.selectedPoint = this.defaultMapPoint;
            }

        } else {
            this.selectedPoint.lng = lng;
            this.selectedPoint.lat = lat;
        }

        setTimeout(()=>{
            let mapa = PPWidgetApp.getMap();
            let zoom;
            this.ppmapDistance.value = distance;
            this.drawDistanceCircle();
            zoom = this.calculateMapZoom();
            mapa.setView(this.selectedPoint, zoom);
        }, 500);


    }

    isSetAttributeUrl(){

        if(this.urlParams.size<1){
            return false;
        } else {
            const lat = Number(this.urlParams.get('lat'));
            const lng = Number(this.urlParams.get('lng'));

            if( isNaN(lat) || isNaN(lng) ) return false;
            if( 0==lat || 0===lng ) return false;

            if(typeof lat == "number" && typeof lng == "number") {
                return true;
            } else {
                return false;
            }
        }
    }

    ppwidgetOnURL(selectedPoint, zoom, showMarker = true) {

        selectedPoint = selectedPoint ?? {selected: this.defaultMapPoint};

        let mapa = PPWidgetApp.getMap();
        let point;

        this.mapPOILoaderResultTable.innerHTML = null;
        mapa._sizeChanged = true;
        this.selectedPoint = selectedPoint;

        this.getFilteredMarkers(true);
        this.calculateMapZoom();
        this.ppmapSearchAdress.value ? mapa.setView(this.selectedPoint, zoom) : mapa.setView([this.defaultMapPoint.lat, this.defaultMapPoint.lng],5.5);

    }

    hasZoomendClass(container) {
        let zoomClass = new Array();
        if(undefined!==container && container!==null) {
            const re = new RegExp(/zoomend\d*/g)
            container.classList.value.matchAll(re).forEach((item)=>{
                zoomClass.push(item[0]);
            });
        }
        return zoomClass;
    }

    start() {

        let mapa = this.mapa;
        let poi = this;

        this.setUrlAttribute();
        this.setUrlFiltersType();
        this.setUrlDays();
        this.setUrlProvince();
        this.setUrlDistance();
        this.filtersActiveCount();

        PPWidgetApp.embedMap('map', { options: { basemapProvider: "AzureMaps", geocoderProvider: "Nominatim"} }).then(function() {

            mapa = PPWidgetApp.getMap();
            mapa.setView([poi.defaultMapPoint.lat, poi.defaultMapPoint.lng],5.5);

            if(poi.isSetAttributeUrl()){

                const lat = Number(poi.urlParams.get('lat'));
                const lng = Number(poi.urlParams.get('lng'));
                let zoom = Number(poi.urlParams.get('zoom'));
                const point = {'lat':lat,'lng':lng,'val':''}
                zoom = (0==zoom) ? 5.5 : zoom;
                poi.ppwidgetOnURL(point, zoom, false);
                mapa.setView([lat, lng],zoom);
            } else {
                poi.ppwidgetOnSubmit({selected: poi.defaultMapPoint},false);
            }

            mapa.on('zoomend', (e) => {

                const container = e.sourceTarget.boxZoom._container;
                const cZoom = 'zoomend' + e.sourceTarget._animateToZoom;
                let index = new Number();

                if(undefined!==container && container!==null) {
                    poi.hasZoomendClass(container).forEach((item)=>{
                        container.classList.remove(item);
                    });
                    container.classList.add(cZoom);
                }

            });

        });


    }

}
let mapPOILoader = new MapPOILoader();

document.addEventListener('DOMContentLoaded', function () {
    mapPOILoader.start();

    //  Location btn in input field
    setTimeout(() => {
        const mapPOILocateBtn = document.querySelector('.leaflet-control-locate a');
        if(mapPOILocateBtn) {
            const ppmapInputLocationButton = document.querySelector('#ppMapLocationButton');
            ppmapInputLocationButton.addEventListener('click', () => {
                mapPOILocateBtn.click();
            });
        }

    }, 900);



}, false);


// filters=all,pocztexAutomat,postOffice,pocztexPoint,outbox
// days=24h,workingDays,soboty,sunday,workingDays
//
// CurrencyExchange=1,
// PickupAtPocztexPoint=1,
// pocztexBroadcasting=1,
// PostOfficeBoxes=1,
// Weight20Plus=1,
// Weight30To50=1,
// MoneyExpress=1,
// ECommerce=1,
// KEP=1,
// COD=1,
// card=1,
// HoursOfEmptying=1,
// SpecialNeeds=1
//
// zoom=12
// lat=49.767519
// lng=19.0770837
//
// ?lng=19.0770837&lat=49.767519&zoom=15&filters=postOffice
// ?CurrencyExchange=1&days=sunday&PickupAtPocztexPoint=1&pocztexBroadcasting=1&PostOfficeBoxes=1&Weight20Plus=1&filters=all&SpecialNeeds=1&HoursOfEmptying=1